import React from 'react';

const UnlinkCrossIcon = ({ stroke = 'currentColor', width = '10', height = '10' }) => (
    <svg viewBox="0 0 10 10" width={width} height={height} aria-hidden="true">
        <path d="M1.5 1.5l7 7M8.5 1.5l-7 7" stroke={stroke} strokeWidth="1.4" strokeLinecap="round" />
    </svg>
);

export default UnlinkCrossIcon;
